import { Logo } from "../branded/Logo";

/**
 * Logo da PlayPro nos dois temas (o asset `color` some em fundo escuro). A
 * versão escura é decorativa para leitor de tela — o título da página já diz
 * onde a pessoa está, e o nome não precisa ser lido duas vezes.
 */
export function MarcaDoSistema({ size = 36 }: { size?: number }) {
  return (
    <div className="flex justify-center" data-pps-component="marca-do-sistema">
      <span className="dark:hidden">
        <Logo size={size} tone="color" />
      </span>
      <span className="hidden dark:inline-block" aria-hidden="true">
        <Logo size={size} tone="light" />
      </span>
    </div>
  );
}
